import { STATUS, STATUS_ORDER, OCCURRENCE } from "@/lib/meta";
import { Check } from "lucide-react";

export function StatusBadge({ status, testId }) {
  const s = STATUS[status] || { label: status, cls: "text-slate-300 bg-slate-800 border-slate-600" };
  return (
    <span data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center rounded-sm border px-2.5 py-1 text-xs font-bold uppercase tracking-wide font-mono ${s.cls}`}>
      {s.label}
    </span>
  );
}

export function OccurrenceBadges({ tipos = [] }) {
  if (!tipos.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="occurrence-badges">
      {tipos.map((t) => {
        const o = OCCURRENCE[t];
        if (!o) return null;
        const Icon = o.icon;
        return (
          <span key={t} className={`inline-flex items-center gap-1 rounded-sm border px-2 py-0.5 text-[10px] font-bold uppercase font-mono ${o.cls}`}>
            <Icon className="w-3 h-3" /> {o.label}
          </span>
        );
      })}
    </div>
  );
}

export function StatusTimeline({ current }) {
  if (current === "CANCELADO") {
    return <div className="text-red-300 font-mono text-sm border border-red-600 rounded px-3 py-2 bg-red-950/50">PEDIDO CANCELADO</div>;
  }
  const curIdx = STATUS_ORDER.indexOf(current);
  return (
    <div className="flex gap-1 overflow-x-auto pb-2" data-testid="status-timeline">
      {STATUS_ORDER.map((st, i) => {
        const done = i < curIdx;
        const active = i === curIdx;
        const s = STATUS[st];
        return (
          <div key={st} className="flex flex-col items-center min-w-[86px] shrink-0">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 text-xs font-bold ${
              active ? "border-primary bg-primary text-primary-foreground shadow-[0_0_12px_rgba(245,158,11,0.5)]"
              : done ? "border-emerald-500 bg-emerald-500/20 text-emerald-300"
              : "border-border bg-card text-muted-foreground"}`}>
              {done ? <Check className="w-4 h-4" /> : i + 1}
            </div>
            <div className={`text-[9px] mt-1 text-center uppercase font-mono leading-tight ${active ? "text-primary" : done ? "text-emerald-300" : "text-muted-foreground"}`}>
              {s.label}
            </div>
            {i < STATUS_ORDER.length - 1 && (
              <div className={`h-0.5 w-full -mt-[26px] translate-x-1/2 ${done ? "bg-emerald-500" : "bg-border"}`} style={{ position: "relative", zIndex: -1 }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
